import auth from '../auth'

import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
import OnboardLayout from '../components/Dashboard/Layout/OnboardLayout.vue'

// Onboarding Page
import getStarted from 'src/components/Dashboard/Views/Onboarding/Wizard.vue'

// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'

// Dashboard pages
const Overview = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Dashboard.vue')
const Widgets = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Widgets.vue')

// Pages
import Login from 'src/components/Dashboard/Views/Pages/Login.vue'
import Register from 'src/components/Dashboard/Views/Pages/Register.vue'
import ForgotPassword from 'src/components/Dashboard/Views/Pages/ForgotPassword.vue'
import ResetPassword from 'src/components/Dashboard/Views/Pages/ResetPassword.vue'
import ShowVerificationNotice from 'src/components/Dashboard/Views/Pages/Verify.vue'
import EmailVerification from 'src/components/Dashboard/Views/Pages/VerifyEmail.vue'
import ResendVerificationEmail from 'src/components/Dashboard/Views/Pages/ResendVerificationEmail.vue'
import Lock from 'src/components/Dashboard/Views/Pages/Lock.vue'



// Transactions pages
import Transactions from 'src/components/Dashboard/Views/Transactions/List.vue'
import TransactionsCreate from 'src/components/Dashboard/Views/Transactions/Create.vue'
import TransactionsEdit from 'src/components/Dashboard/Views/Transactions/Edit.vue'

// Budget pages
import Budget from 'src/components/Dashboard/Views/Budget/List.vue'
import BudgetCreate from 'src/components/Dashboard/Views/Budget/Create.vue'
import BudgetEdit from 'src/components/Dashboard/Views/Budget/Edit.vue'

// Goals pages
import Goals from 'src/components/Dashboard/Views/Goals/List.vue'
import GoalsCreate from 'src/components/Dashboard/Views/Goals/Create.vue'
import GoalsEdit from 'src/components/Dashboard/Views/Goals/Edit.vue'

//Rewards pages
import Rewards from 'src/components/Dashboard/Views/Rewards/List.vue'
import RewardedTransactions from 'src/components/Dashboard/Views/Rewards/RewardedTransactions.vue'

// Financial Services pages
import FinServices from 'src/components/Dashboard/Views/FinServices/List.vue'

// Progress pages
import Progress from 'src/components/UIComponents/Progress.vue'

// Settings pages
import Settings from 'src/components/Dashboard/Views/Settings/List.vue'
import MonthlyBudget from 'src/components/Dashboard/Views/Settings/MonthlyBudget.vue'
import MonthlyIncome from 'src/components/Dashboard/Views/Settings/MonthlyIncome.vue'
import MyCategories from 'src/components/Dashboard/Views/Settings/Categories.vue'
import MyAccounts from 'src/components/Dashboard/Views/Settings/Accounts.vue'

// Accounts pages
import MyAccountsAdd from 'src/components/Dashboard/Views/Settings/AccountAdd.vue'
import MyAccountSync from 'src/components/Dashboard/Views/Settings/AccountSync.vue'

// User Profile pages
import Profile from 'src/components/Dashboard/Views/User/List.vue'
import UpdatePassword from 'src/components/Dashboard/Views/User/ChangePwd.vue'

// Components pages
import Buttons from 'src/components/Dashboard/Views/Components/Buttons.vue'
import GridSystem from 'src/components/Dashboard/Views/Components/GridSystem.vue'
import Panels from 'src/components/Dashboard/Views/Components/Panels.vue'
import SweetAlert from 'src/components/Dashboard/Views/Components/SweetAlert.vue'
import Notifications from 'src/components/Dashboard/Views/Components/Notifications.vue'
import Icons from 'src/components/Dashboard/Views/Components/Icons.vue'
import Typography from 'src/components/Dashboard/Views/Components/Typography.vue'

//Financial Services Plugin
import PluginRewardsCreate from 'src/components/Dashboard/Views/FinServices/Rewards/Create.vue'
import PluginRewardsList from 'src/components/Dashboard/Views/FinServices/Rewards/List.vue'
import PluginRewardsCustomers from 'src/components/Dashboard/Views/FinServices/Rewards/Customers.vue'

// Forms pages
const RegularForms  = () => import(/* webpackChunkName: "forms" */ 'src/components/Dashboard/Views/Forms/RegularForms.vue')
const ExtendedForms = () => import(/* webpackChunkName: "forms" */ 'src/components/Dashboard/Views/Forms/ExtendedForms.vue');
const ValidationForms = () => import(/* webpackChunkName: "forms" */ 'src/components/Dashboard/Views/Forms/ValidationForms.vue')
const Wizard = () => import(/* webpackChunkName: "forms" */ 'src/components/Dashboard/Views/Forms/Wizard.vue');

// TableList pages
const RegularTables = () => import(/* webpackChunkName: "tables" */ 'src/components/Dashboard/Views/Tables/RegularTables.vue');
const ExtendedTables = () => import(/* webpackChunkName: "tables" */ 'src/components/Dashboard/Views/Tables/ExtendedTables.vue');
const PaginatedTables = () => import(/* webpackChunkName: "tables" */ 'src/components/Dashboard/Views/Tables/PaginatedTables.vue');
// Maps pages
const GoogleMaps = () => import(/* webpackChunkName: "maps" */ 'src/components/Dashboard/Views/Maps/GoogleMaps.vue')
const FullScreenMap = () => import(/* webpackChunkName: "maps" */ 'src/components/Dashboard/Views/Maps/FullScreenMap.vue')
const VectorMaps = () => import(/* webpackChunkName: "maps" */ 'src/components/Dashboard/Views/Maps/VectorMapsPage.vue');

// Calendar
import Calendar from 'src/components/Dashboard/Views/Calendar/CalendarRoute.vue'
// Charts
const Charts = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Charts.vue')

function requireAuth (to, from, next) {
  if (!auth.loggedIn()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
}

function requireNotLoggedIn (to, from, next) {
  if (auth.loggedIn ()) {
    
    if (from.fullPath  == '/') {
      next('/logout')
    }
    else {
      next ({
        path: from.fullPath,
        query: { redirect: from.fullPath }
      })
      
    }
  } 
  else {
    next()
  }  
}

function requireRegistered (to, from, next) {
 
  if (from.path  != '/register') {
    auth.logout ()
    next('/register')
  }else {
    if (auth.getToken()) {
      next()
    } else {
      next('/register')
    }
  }
}

function requireOnboarding (to, from, next) {
  if (from.fullPath  != '/get-started/step-1') {
    auth.logout ()
    next('/register')
  }else {
    next()
  }
}

let componentsMenu = {
  path: '/components',
  component: DashboardLayout,
  redirect: '/components/buttons',
  children: [
    {
      path: 'buttons',
      name: 'Buttons',
      component: Buttons
    },
    {
      path: 'grid-system',
      name: 'Grid System',
      component: GridSystem
    },
    {
      path: 'panels',
      name: 'Panels',
      component: Panels
    },
    {
      path: 'sweet-alert',
      name: 'Sweet Alert',
      component: SweetAlert
    },
    {
      path: 'notifications',
      name: 'Notifications',
      component: Notifications
    },
    {
      path: 'icons',
      name: 'Icons',
      component: Icons
    },
    {
      path: 'typography',
      name: 'Typography',
      component: Typography
    }

  ]
}
let formsMenu = {
  path: '/forms',
  component: DashboardLayout,
  redirect: '/forms/regular',
  children: [
    {
      path: 'regular',
      name: 'Regular Forms',
      component: RegularForms
    },
    {
      path: 'extended',
      name: 'Extended Forms',
      component: ExtendedForms
    },
    {
      path: 'validation',
      name: 'Validation Forms',
      component: ValidationForms
    },
    {
      path: 'wizard',
      name: 'Wizard',
      component: Wizard
    }
  ]
}

let tablesMenu = {
  path: '/table-list',
  component: DashboardLayout,
  redirect: '/table-list/regular',
  children: [
    {
      path: 'regular',
      name: 'Regular Tables',
      component: RegularTables
    },
    {
      path: 'extended',
      name: 'Extended Tables',
      component: ExtendedTables
    },
    {
      path: 'paginated',
      name: 'Paginated Tables',
      component: PaginatedTables
    }]
}

let mapsMenu = {
  path: '/maps',
  component: DashboardLayout,
  redirect: '/maps/google',
  children: [
    {
      path: 'google',
      name: 'Google Maps',
      component: GoogleMaps
    },
    {
      path: 'full-screen',
      name: 'Full Screen Map',
      component: FullScreenMap
    },
    {
      path: 'vector-map',
      name: 'Vector Map',
      component: VectorMaps
    }
  ]
}

let onboardingPage = {
  path: '/get-started/step-1',
  name: 'Get Started',
  component: getStarted,
  beforeEnter: requireRegistered
}

let loginPage = {
  path: '/login',
  name: 'Login',
  component: Login,
  beforeEnter: requireNotLoggedIn
}

let registerPage = {
  path: '/register',
  name: 'Register',
  component: Register,
  beforeEnter: requireNotLoggedIn
}





let lockPage = {
  path: '/lock',
  name: 'Lock',
  component: Lock
}

let forgotPage = {
  path: '/forgot-password',
  name: 'ForgotPassword',
  component: ForgotPassword,
  
}

let resetPage = {
  path: '/reset-password',
  name: 'ResetPassword',
  component: ResetPassword, 
}

let verifyPage = {
  path: '/verify',
  name: 'Verify',
  component: ShowVerificationNotice, 
  beforeEnter: requireRegistered
}

let emailVerificationPage = {
  path: '/verify-email',
  name: 'Verify Email',
  component: EmailVerification, 
}

let resendVerificationEmailPage = {
  path: '/resend-email',
  name: 'Resend Verification Email',
  component: ResendVerificationEmail, 
}


const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/login',
    
    children: [
      {
        path: 'calendar',
        name: 'Calendar',
        component: Calendar
      },
      {
        path: 'charts',
        name: 'Charts',
        component: Charts
      },
      {
        path: '/progress',
        name: 'Progress',
        component: Progress,
        
      },
      {
        path: '/transactions',
        name: 'Transactions',
        component: Transactions,
        beforeEnter: requireAuth
      },
      {
        path: '/transactions/add',
        name: 'Add Transaction',
        component: TransactionsCreate,
        beforeEnter: requireAuth
      },
      {
        path: '/transactions/update/:id',
        name: 'Update Transaction',
        component: TransactionsEdit,
        beforeEnter: requireAuth
      },
      {
        path: '/budget',
        name: 'Budget',
        component: Budget,
        beforeEnter: requireAuth
      },
      {
        path: '/budget/add',
        name: 'Add Budget',
        component: BudgetCreate,
        beforeEnter: requireAuth
      },
      {
        path: '/budget/update/:id',
        name: 'Update Budget',
        component: BudgetEdit,
        beforeEnter: requireAuth
      },
      {
        path: '/goals',
        name: 'Goals',
        component: Goals,
        beforeEnter: requireAuth
      },
      {
        path: '/goals/add',
        name: 'Add Goal',
        component: GoalsCreate,
        beforeEnter: requireAuth
      },
      {
        path: '/goals/update/:id',
        name: 'Update Goal',
        component: GoalsEdit,
        beforeEnter: requireAuth
      },
      {
        path: '/rewards',
        name: 'Rewards',
        component: Rewards,
        beforeEnter: requireAuth
      },
      {
        path: '/rewards/:merchant/transactions',
        name: 'Reward Transactions',
        component: RewardedTransactions,
        beforeEnter: requireAuth
      },
      {
        path: '/plugins',
        name: 'Add Financial Service',
        component: FinServices,
        beforeEnter: requireAuth
      },
      {
        path: '/settings',
        name: 'Settings',
        component: Settings,
        beforeEnter: requireAuth
      },
      {
        path: '/settings/budget',
        name: 'Monthly Budget',
        component: MonthlyBudget,
        beforeEnter: requireAuth
      },
      {
        path: '/settings/income',
        name: 'Monthly Income',
        component: MonthlyIncome,
        beforeEnter: requireAuth
      },
      {
        path: '/settings/categories',
        name: 'My Categories',
        component: MyCategories,
        beforeEnter: requireAuth
      },
      {
        path: '/settings/accounts',
        name: 'My Accounts',
        component: MyAccounts,
        beforeEnter: requireAuth
      },
      {
        path: '/settings/accounts/add',
        name: 'Link Account',
        component: MyAccountsAdd,
        beforeEnter: requireAuth
      },
      {
        path: '/settings/accounts/:id/sync',
        name: 'Sync Account',
        component: MyAccountSync,
        beforeEnter: requireAuth
      },
      {
        path: '/profile',
        name: 'Profile',
        component: Profile,
        beforeEnter: requireAuth
      },
      {
        path: '/profile/password',
        name: 'Update Password',
        component: UpdatePassword,
        beforeEnter: requireAuth
      },
      {
        path: 'overview',
        name: 'Overview',
        component: Overview,
        beforeEnter: requireAuth
      },
      {
        path: '/logout',
        beforeEnter (to, from, next){
          auth.logout ()
          next('/')
        }
      },
      {
        path: '/plugins/rewards/create',
        name: 'Create Reward',
        component: PluginRewardsCreate,
        beforeEnter: requireAuth
      },
      {
        path: '/plugins/rewards',
        name: 'Your Reward Programs',
        component: PluginRewardsList,
        beforeEnter: requireAuth
      },
      {
        path: '/plugins/rewards/customers',
        name: 'Point Earn Redeem',
        component: PluginRewardsCustomers,
        beforeEnter: requireAuth
      },
    ]
  },
  componentsMenu,
  formsMenu,
  tablesMenu,
  mapsMenu,
 
  loginPage,
  registerPage,

  lockPage,
  forgotPage, resetPage, verifyPage, emailVerificationPage, resendVerificationEmailPage, onboardingPage,
  {path: '*', component: NotFound}
];

export default routes
